export default __webpack_public_path__ + "static/media/stake-more-zenusdt.32d6274a.svg";